import React, { Component } from "react";
import fullimg from "./fst.jpg";
export default class FullStackImg extends Component {
  render() {
    return <img src={fullimg} alt="helo" />;
  }
}
